import { render, staticRenderFns } from "./IconCircleArrow.vue?vue&type=template&id=46645108&scoped=true&"
var script = {}
import style0 from "./IconCircleArrow.vue?vue&type=style&index=0&id=46645108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46645108",
  null
  
)

export default component.exports